
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import infoGetActions from '../../sagas/info';
import { getObjectInfo } from '../../reducers/info';

import IsknOpsubObject from '../common/iskn/IsknOpsubObject';
import IsknParObject from '../common/iskn/IsknParObject';
import IsknTelObject from '../common/iskn/IsknTelObject';
import InfoLoading from './InfoLoading';
import InfoNotFound from './InfoNotFound';

const classNames = mergeStyleSets({
    root: {
        width: 450
    },
    content: {
        padding: 16,
        paddingTop: 0,
        overflowY: 'auto',
        height: 100 // fix
    },
    closeButton: {
        width: 16,
        padding: '4px',
        cursor: 'pointer',
        color: '#aaaaaa',
        selectors: {
            ':hover': {
                color: '#000000'
            }
        }
    },
    closeButtonIcon: {
        fontSize: 16,
        height: 16,
        width: 16,
        margin: '0 0 0 0'
    },
    footer: {
        height: 32
    }
});

const ObjectInfoContent = ({isknDate}) => {

    const info = useSelector(state => state.info);
    const objectInfo = useSelector(state => getObjectInfo(state.info));

    if (info.loading) {
        return <InfoLoading />;
    }

    if (objectInfo) {
        switch (objectInfo.type) {
            case 'NOT_FOUND':
                return <InfoNotFound />;
            case 'PARCELA':
                return <IsknParObject isknDate={isknDate} objectInfo={objectInfo} />;
            case 'OPSUB':
                return <IsknOpsubObject isknDate={isknDate} objectInfo={objectInfo} />;
            case 'TELESO':
                return <IsknTelObject isknDate={isknDate} objectInfo={objectInfo} />;
            default:
                return null;
        }
    }

    return null;
}

const IsknObjectInfo = ({isknDate}) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);

    const infoVisible = useSelector(state => {
        return state.info.visible;
    });

    const onClick = () => {
        infoActions.close();
    }

    return (infoVisible &&
        <Stack verticalFill className={classNames.root}>
            <Stack horizontalAlign="end">
                <div className={classNames.closeButton} onClick={onClick}>
                    <FontIcon
                        iconName="Cancel"
                        className={classNames.closeButtonIcon}
                        title="Zavřít"
                    />
                </div>
            </Stack>
            <Stack.Item grow className={classNames.content}>
                <ObjectInfoContent isknDate={isknDate} />
            </Stack.Item>
            <Stack.Item className={classNames.footer}>
                <div></div>
            </Stack.Item>
        </Stack>
    );
}

export default IsknObjectInfo;
